import React from 'react';
import Helmet from 'react-helmet';
import { Handler }  from 'ml-component-web';
import ModalContainer from '../shared/modal/ModalContainer';

export default class MyBabyBioHandler extends Handler {

    componentWillReceiveProps(nextProps) {
        // if we changed routes, but not between modals...
        if (nextProps.location.key !== this.props.location.key
            && nextProps.location.state
            && nextProps.location.state.modal
            && (!this.props.location.state || !this.props.location.state.modal)) {
            // save the old children (just like animation)
            this.previousChildren = this.props.children;
        }
    }

    renderHandler() {
        const {
            location,
        } = this.props;
        const locationState = location.state;
        const isModal = locationState && locationState.modal && this.previousChildren;

        const content = isModal ? this.previousChildren : this.props.children;
        const modalContent = isModal ? this.props.children : undefined;
        return (
            <div>
                <Helmet
                    htmlAttributes={{ lang: 'en' }}
                />
                {content}
                <ModalContainer>
                    {modalContent}
                </ModalContainer>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/MyBabyBioHandler.js
 **/